import { adminHttpClient } from '../../commons/adminHttpClient'
import moment from 'moment'

export interface GroupHealthPlanApiValues {
  id: string
  groupHealthPlanStartDate?: string
  groupHealthPlanName: string
  insuranceCarrier: string
  waitingPeriod: number
}

export interface GroupHealthPlanPageValues extends GroupHealthPlanApiValues {
  waitingPeriodInput?: number | undefined
}

const groupHealthPlanApi = (values: GroupHealthPlanPageValues): Promise<any> => {
  const data = {
    id: values.id,
    startDate: moment(values.groupHealthPlanStartDate).format('YYYY-MM-DD'),
    planName: values.groupHealthPlanName,
    insuranceCarrier: values.insuranceCarrier,
    waitingPeriod: values.waitingPeriod,
  }

  return adminHttpClient.post('/AdminSignup/gchra/GroupHealthPlan/GroupHealthPlan', data)
}

export default groupHealthPlanApi
